"use client"

import { useState } from "react"
import { Link } from "react-router-dom"
import { Badge } from "../../components/ui/badge"
import { Button } from "../../components/ui/button"
import { Input } from "../../components/ui/input"
import SEO from "../SEO"
import { Newspaper, Calendar, ExternalLink, Search, TrendingUp, Users, Award, Building2 } from "lucide-react"

export default function InTheNews() {
  const inTheNewsSchema = [
  {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    "name": "Pranaam Hospitals",
    "url": "https://pranaam.pranaamhospitals.in/",
    "logo": "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/logo.png",
    "description": "Pranaam Hospitals is a NABH-accredited multi-specialty hospital in Hyderabad recognized for excellence in patient care, advanced treatments, and community healthcare initiatives.",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Hyderabad",
      "addressRegion": "Telangana",
      "addressCountry": "IN"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "telephone": "+91-99660-60000",
      "availableLanguage": ["English", "Telugu", "Hindi"]
    },
    "sameAs": [
      "https://www.facebook.com/pranaamhospitals",
      "https://www.instagram.com/pranaamhospitals",
      "https://www.linkedin.com/company/pranaamhospitals"
    ]
  },

  {
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://pranaam.pranaamhospitals.in/about/inthenews"
    },
    "headline": "Pranaam Hospitals in the News",
    "description": "Media coverage and news highlights featuring Pranaam Hospitals’ medical excellence, innovations, awards, and contributions to healthcare in Hyderabad.",
    "image": "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/pranaam-hospitals-news.jpg",
    "author": {
      "@type": "Organization",
      "name": "Pranaam Hospitals"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Pranaam Hospitals",
      "logo": {
        "@type": "ImageObject",
        "url": "https://pranaam.pranaamhospitals.in/wp-content/uploads/2025/logo.png"
      }
    },
    "datePublished": "2016-01-01",
    "dateModified": "2025-04-01",
    "keywords": [
      "Pranaam Hospitals news",
      "Pranaam Hospitals media coverage",
      "hospital awards Hyderabad",
      "healthcare news Hyderabad",
      "best hospital in Hyderabad"
    ]
  }
];

  const [searchQuery, setSearchQuery] = useState("")
  const [selectedYear, setSelectedYear] = useState("all")

  const newsArticles = [
    {
      publication: "India Today",
      date: "1 Jul 2025",
      headline: "Sigachi Industries Explosion: Injured Rushed to Pranaam Hospital",
      year: "2025",
    },
    {
      publication: "Devdiscourse",
      date: "1 Jul 2025",
      headline: "Pranaam Hospital Treats Victims of Sigachi Pashamylaram Blast",
      year: "2025",
    },
    {
      publication: "Vibes of India",
      date: "1 Jul 2025",
      headline: "Pranaam Hospital Treats Sigachi Victims Amid Severe Burns and Toxic Exposure",
      year: "2025",
    },
    {
      publication: "Udayavani",
      date: "1 Jul 2025",
      headline: "Pranaam Hospital Treats Victims of Sigachi Pashamylaram Blast",
      year: "2025",
    },
    {
      publication: "Andhrajyothy",
      date: "30 Jun 2025",
      headline: "Explosion Cause Confirmed; Pranaam Hospital Cares for Victims",
      year: "2025",
    },
    {
      publication: "Daily Excelsior",
      date: "2 Jul 2025",
      headline: "Pranaam Hospital Treats Sigachi Blast Victims as Toll Rises to 36",
      year: "2025",
    },
    {
      publication: "The CSR Journal",
      date: "1 Jul 2025",
      headline: "Rescue Efforts Continue After Sigachi Blast; Pranaam Hospital Supports Injured",
      year: "2025",
    },
    {
      publication: "PTI via Facebook",
      date: "1 Jul 2025",
      headline: "Pranaam Hospital Supports Victims of Sigachi Pashamylaram Blast",
      year: "2025",
    },
    {
      publication: "New Indian Express",
      date: "1 Jul 2025",
      headline: "Pranaam Hospital Treats Injured as Death Toll in Telangana Blast Rises",
      year: "2025",
    },
    {
      publication: "The News Minute",
      date: "2 Jul 2025",
      headline: "Pranaam Hospital Helps Victims as Sigachi Faces Charges",
      year: "2025",
    },
    {
      publication: "Editorji News Desk",
      date: "1 Jul 2025",
      headline: "Pashamylaram Sigachi Blast: Pranaam Hospital at Forefront of Emergency Care",
      year: "2025",
    },
    {
      publication: "Millennium Post",
      date: "1 Jul 2025",
      headline: "Sigachi Industries Blast: Pranaam Hospital's Critical Role During Rescue Operations",
      year: "2025",
    },
    {
      publication: "Firstpost",
      date: "1 Jul 2025",
      headline: "Sigachi Spray-Dryer Explosion: Pranaam Hospital Responds to Critical Injuries",
      year: "2025",
    },
    {
      publication: "The CSR Journal",
      date: "1 Jul 2025",
      headline: "Sigachi Industries Blast: Pranaam Hospital Provides Critical Care to Victims",
      year: "2025",
    },
    {
      publication: "Economic Times",
      date: "1 Jul 2025",
      headline: "Sigachi Industries Blast: Pranaam Hospital Provides Emergency Care",
      year: "2025",
    },
    {
      publication: "Telangana Today",
      date: "19 Feb 2024",
      headline: "Pranaam Hospital collaborates with MedLern",
      year: "2024",
    },
    {
      publication: "The Hindu",
      date: "11 Sept 2024",
      headline: "Pranaam Hospitals inks MoU with MedTech Society for Make in India Hospitals",
      year: "2024",
    },
    {
      publication: "Telangana Today",
      date: "12 Sept 2024",
      headline: "Pranaam Hospitals forges a historic collaboration with Make in India Hospitals at Hyderabad and Vizag",
      year: "2024",
    },
    {
      publication: "Press Trust of India",
      date: "17 Oct 2024",
      headline: "Dr. Annie Stanley Thakore- A Visionary Leader's Journey to Success",
      year: "2024",
    },
    {
      publication: "Telangana Today",
      date: "16 Aug 2024",
      headline:
        "Doctors at Pranaam Hospitals to suspend duties on Saturday in solidarity with Telangana IMA announcement",
      year: "2024",
    },
    {
      publication: "eHealth Magazine",
      date: "6 Mar 2024",
      headline: "Pranaam Hospital Embarks on Digital Training Transformation with Medlern Partnership",
      year: "2024",
    },
    {
      publication: "Telangana Today",
      date: "17 Sept 2023",
      headline: "Any Time Clinic (ATC) In Hyderabad: Digital Kiosk For Instant Health Checkup | Pranaam Hospitals",
      year: "2023",
    },
    {
      publication: "BizzBuzz",
      date: "8 Jul 2023",
      headline: "Pranaam Karkinos cancer unit opens in Hyd",
      year: "2023",
    },
    {
      publication: "Munsifdaily.com",
      date: "17 Sept 2023",
      headline:
        "Pranaam Hospitals and Gem Opencube Technologies Announce Innovative 'Any Time Clinic' and Health ATM Initiative",
      year: "2023",
    },
    {
      publication: "Times of India",
      date: "17 Jul 2021",
      headline: "Pranaam Hospitals: Humane Care for Human Cure",
      year: "2021",
    },
    {
      publication: "10 TV Digital Team",
      date: "23 Dec 2020",
      headline: "The Doctor Who Saved The Baby's Life During The Flight Travel",
      year: "2020",
    },
  ]

  const years = ["all", "2025", "2024", "2023", "2021", "2020"]

  const filteredNews = newsArticles.filter((article) => {
    const matchesSearch =
      article.headline.toLowerCase().includes(searchQuery.toLowerCase()) ||
      article.publication.toLowerCase().includes(searchQuery.toLowerCase())
    const matchesYear = selectedYear === "all" || article.year === selectedYear
    return matchesSearch && matchesYear
  })

  return (
    <>
    <SEO
  title="Pranaam Hospitals in the News | Media Coverage & Healthcare Achievements"
  description="Explore Pranaam Hospitals in the news — media coverage, press mentions, awards, and recognitions highlighting our excellence in healthcare services in Hyderabad."
  canonical="https://pranaam.pranaamhospitals.in/about/inthenews"
  robots="index, follow"
  author="Pranaam Hospitals"
  publisher="Pranaam Hospitals"
  keywords="Pranaam Hospitals in the news, Pranaam Hospitals media coverage,
            hospital news Hyderabad, healthcare achievements Hyderabad,
            Pranaam Hospitals press releases, best hospital in Hyderabad news"
  schema={inTheNewsSchema}
/>

    <div className="min-h-screen bg-white">
      <main>
        {/* Hero Section */}
        <section className="relative bg-gradient-to-r from-primary/10 to-primary/5 py-16 md:py-24">
          <div className="container px-4 mx-auto">
            <div className="max-w-4xl mx-auto text-center">
              <Badge className="mb-4 px-3 py-1">Media Coverage</Badge>
              <h1 className="mb-6 text-4xl font-bold tracking-tight md:text-5xl lg:text-6xl">
                In The <span className="text-primary">News</span>
              </h1>
              <p className="mb-8 text-lg text-gray-700 max-w-3xl mx-auto">
                Discover how Pranaam Hospitals continues to make headlines through our emergency response, innovative
                healthcare solutions, and commitment to community wellbeing.
              </p>
              <div className="flex flex-wrap justify-center gap-4 mt-8">
                <Badge variant="outline" className="px-4 py-2 text-base">
                  <Newspaper className="w-4 h-4 mr-2" />
                  26+ Media Mentions
                </Badge>
                <Badge variant="outline" className="px-4 py-2 text-base">
                  <Calendar className="w-4 h-4 mr-2" />6 Years Featured
                </Badge>
                <Badge variant="outline" className="px-4 py-2 text-base">
                  <TrendingUp className="w-4 h-4 mr-2" />
                  National & Regional
                </Badge>
              </div>
            </div>
          </div>
        </section>

        {/* Introduction */}
        <section className="py-12 bg-white">
          <div className="container px-4 mx-auto">
            <div className="max-w-3xl mx-auto text-center">
              <p className="text-lg text-gray-700">
                Pranaam Hospitals has been consistently recognized by leading media outlets for our exceptional
                healthcare services, rapid emergency response, groundbreaking innovations like India's first Health ATM,
                and strategic partnerships that advance the medical field.
              </p>
            </div>
          </div>
        </section>

        {/* Search and Filter Section */}
        <section className="py-8 bg-gray-100">
          <div className="container px-4 mx-auto">
            <div className="max-w-4xl mx-auto space-y-6">
              {/* Search Bar */}
              <div className="relative">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                <Input
                  type="text"
                  placeholder="Search articles by headline or publication..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="pl-10 h-12 bg-white"
                />
              </div>

              {/* Year Filter */}
              <div className="flex flex-wrap gap-3 justify-center">
                {years.map((year) => (
                  <Button
                    key={year}
                    variant={selectedYear === year ? "default" : "outline"}
                    onClick={() => setSelectedYear(year)}
                    className="rounded-full"
                  >
                    {year === "all" ? "All Years" : year}
                  </Button>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* News Grid */}
        <section className="py-12 bg-white">
          <div className="container px-4 mx-auto">
            <div className="max-w-6xl mx-auto">
              {filteredNews.length > 0 ? (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {filteredNews.map((article, index) => (
                    <div
                      key={index}
                      className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-all group"
                    >
                      <div className="flex items-start gap-4">
                        <div className="flex-shrink-0">
                          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 group-hover:bg-primary transition-colors">
                            <Newspaper className="w-6 h-6 text-primary group-hover:text-white transition-colors" />
                          </div>
                        </div>
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 mb-2">
                            <Calendar className="w-4 h-4 text-primary flex-shrink-0" />
                            <span className="text-sm text-gray-600">{article.date}</span>
                          </div>
                          <h3 className="font-bold mb-2 text-gray-900 group-hover:text-primary transition-colors line-clamp-2">
                            {article.headline}
                          </h3>
                          <p className="text-sm text-gray-600 mb-3">{article.publication}</p>
                          <Button
                            variant="ghost"
                            size="sm"
                            className="text-primary hover:text-primary/80 p-0 h-auto font-medium"
                          >
                            Read Article
                            <ExternalLink className="w-4 h-4 ml-1" />
                          </Button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-12">
                  <Newspaper className="w-16 h-16 text-gray-300 mx-auto mb-4" />
                  <h3 className="text-xl font-semibold mb-2">No articles found</h3>
                  <p className="text-gray-600 mb-4">Try adjusting your search or filters</p>
                  <Button
                    variant="outline"
                    onClick={() => {
                      setSearchQuery("")
                      setSelectedYear("all")
                    }}
                  >
                    Clear Filters
                  </Button>
                </div>
              )}
            </div>
          </div>
        </section>

        {/* Media Recognition Stats */}
        <section className="py-12 bg-gray-100">
          <div className="container px-4 mx-auto">
            <div className="max-w-6xl mx-auto">
              <div className="text-center mb-12">
                <Badge className="mb-2">Media Impact</Badge>
                <h2 className="mb-4 text-3xl font-bold md:text-4xl">Our Media Recognition</h2>
                <p className="text-muted-foreground max-w-2xl mx-auto">
                  Coverage spanning emergency response, healthcare innovation, and community partnerships
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                <div className="bg-white rounded-lg p-6 text-center border border-gray-200 hover:shadow-md transition-shadow">
                  <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 mb-4">
                    <TrendingUp className="w-6 h-6 text-primary" />
                  </div>
                  <h3 className="text-3xl font-bold text-primary mb-2">15+</h3>
                  <p className="text-gray-600">Emergency Response Coverage</p>
                </div>

                <div className="bg-white rounded-lg p-6 text-center border border-gray-200 hover:shadow-md transition-shadow">
                  <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 mb-4">
                    <Award className="w-6 h-6 text-primary" />
                  </div>
                  <h3 className="text-3xl font-bold text-primary mb-2">10+</h3>
                  <p className="text-gray-600">Innovation Features</p>
                </div>

                <div className="bg-white rounded-lg p-6 text-center border border-gray-200 hover:shadow-md transition-shadow">
                  <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 mb-4">
                    <Building2 className="w-6 h-6 text-primary" />
                  </div>
                  <h3 className="text-3xl font-bold text-primary mb-2">5+</h3>
                  <p className="text-gray-600">Partnership Announcements</p>
                </div>

                <div className="bg-white rounded-lg p-6 text-center border border-gray-200 hover:shadow-md transition-shadow">
                  <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 mb-4">
                    <Users className="w-6 h-6 text-primary" />
                  </div>
                  <h3 className="text-3xl font-bold text-primary mb-2">20+</h3>
                  <p className="text-gray-600">Media Outlets</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-12 bg-white">
          <div className="container px-4 mx-auto">
            <div className="max-w-4xl mx-auto bg-gradient-to-r from-primary to-primary/90 rounded-lg shadow-xl p-8 md:p-12 text-white text-center">
              <h2 className="mb-4 text-3xl font-bold md:text-4xl">Media Inquiries</h2>
              <p className="mb-8 text-lg opacity-90">
                For press releases, interviews, or media partnerships, please contact our media relations team.
              </p>
              <Button size="lg" variant="secondary" asChild>
                <Link href="/contact">Contact Media Relations</Link>
              </Button>
            </div>
          </div>
        </section>
      </main>
    </div>
    </>
  )
}
